import { ParamMap } from '@angular/router';
import { PageInfo } from 'src/assets/types/interface/page-info.interface';
import { buildServiceOrderPageInfo } from './builders/service-order-page-info.builder';
import { buildProposalPageInfo } from './builders/proposal-page-info.builder';
import { buildCompanyEditPageInfo } from './builders/company-edit-page-info';
import { buildNotificationsPageInfo } from './builders/notifications-page-info.builder';
import { buildCompanyPageInfo } from './builders/company-page-info';
import { buildDemandPageInfo } from './builders/demand-page-info.builder';
import { buildServiceOrderChecklistPageInfo } from './builders/service-order-checklist-page-info.builder';
import { readNavigationContext } from 'src/app/services/navigation/navigation-context.service';

export class PageInfoFactory {
  constructor(
    private tenantType: string,
    private isApprover: boolean,
    private services: {
      demandService: any;
      serviceOrderService: any;
      budgetTakerService: any;
      budgetProviderService: any;
      visitService: any;
    },
  ) {}

  async build(
    route: string,
    params: ParamMap,
    queryParams: ParamMap,
  ): Promise<PageInfo> {
    const serviceOrderUuid = params.get('serviceOrderUuid');
    const demandUuid = params.get('demandUuid');
    const proposalUuid = params.get('proposalUuid');
    const budgetUuid = params.get('budgetUuid');

    if (
      route.split(/[?#]/)[0].replace(/\/$/, '').replace(/^\//, '') ===
      'gestao/dashboard'
    )
      return {
        identification: '',
        title: 'Dashboard gerencial',
        pagesAbove: [],
      };

    if (
      route.includes('gestao/ordens-servico/') &&
      route.includes('/checklists') &&
      serviceOrderUuid
    )
      return buildServiceOrderChecklistPageInfo(
        route,
        serviceOrderUuid,
        params.get('checklistUuid'),
        params.get('sourceRevision'),
        queryParams,
        this.tenantType,
        this.services.serviceOrderService,
      );

    if (route.includes('gestao/solicitacoes/detalhes') && demandUuid)
      return buildDemandPageInfo(demandUuid, this.services.demandService);

    if (route.includes('gestao/solicitacoes'))
      return {
        identification: '',
        title: 'Histórico de Solicitações',
        pagesAbove: [],
      };

    if (route.includes('gestao/ordens-servico'))
      return {
        identification: '',
        title: 'Ordens de Serviço',
        pagesAbove: [],
      };

    if (route.includes('gestao/ordem-servico/detalhes') && serviceOrderUuid)
      return buildServiceOrderPageInfo(
        serviceOrderUuid,
        this.tenantType,
        this.services.serviceOrderService,
        readNavigationContext(queryParams),
      );

    if (route.includes('gestao/aprovacoes'))
      return {
        identification: '',
        title: 'Aprovações',
        pagesAbove: [],
      };

    if (route.includes('gestao/agenda'))
      return {
        identification: '',
        title: 'Agenda de Serviços',
        pagesAbove: [],
      };

    if (route.includes('gestao/visitas'))
      return {
        identification: '',
        title: 'Calendário de Visitas',
        pagesAbove: [],
      };

    if (route.includes('gestao/orcamentos/') && proposalUuid)
      return buildProposalPageInfo(
        proposalUuid,
        queryParams.get('budgetUuid'),
        this.tenantType,
        this.isApprover,
        route.includes('/construtor'),
        this.services.budgetTakerService,
        this.services.budgetProviderService,
      );

    if (route.includes('gestao/orcamentos'))
      return {
        identification: '',
        title: 'Orçamentos',
        pagesAbove: [],
      };

    if (route.includes('configuracoes/perfil-empresa/config'))
      return buildCompanyEditPageInfo();

    if (route.includes('configuracoes/perfil-empresa'))
      return buildCompanyPageInfo();

    if (route.includes('plataforma/notificacoes'))
      return buildNotificationsPageInfo();

    return {
      identification: '',
      title: 'Detalhes',
      pagesAbove: [],
    };
  }
}
